"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Cookies = _interopRequireDefault(require("./Cookies"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Cookies["default"];
exports["default"] = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/universal-cookie/cjs/index.js
// module id = 110
// module chunks = 0